import { HistoryView } from "@/admin/metal/machine/HistoryView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/metal/machines/history/$location/$uuid")({
    component: Component,
});

function Component() {
    const params = Route.useParams();
    return <HistoryView params={params} />;
}
